import { useEffect, useRef } from "react";
import type { CarState } from "../types";
import { WINDOWS } from "../types";
import { blowerLevel, bootLatch, chirp, doorThud, engineStart, engineStop, windowMotor } from "../audio";

// Sounds follow *state changes*, so scenes and live telemetry trigger them the same way buttons do.
export function useCarSounds(s: CarState) {
  const prev = useRef<CarState | null>(null);
  useEffect(() => {
    const p = prev.current; prev.current = s;
    if (!p) return; // first render: no sounds for the initial snapshot
    if (s.engineRunning !== p.engineRunning) { if (s.engineRunning) engineStart(); else engineStop(); }
    if (s.locked !== p.locked) chirp(s.locked ? 1 : 2);
    if (s.bootOpen !== p.bootOpen && s.bootOpen) bootLatch();
    for (const d of WINDOWS) if (s.doors[d] !== p.doors[d]) doorThud(s.doors[d]);
    const moved = WINDOWS.filter((w) => Math.abs(s.windows[w] - p.windows[w]) > 2);
    if (moved.length) {
      const travel = Math.max(...moved.map((w) => Math.abs(s.windows[w] - p.windows[w]))) / 100;
      windowMotor(Math.max(0.5, 3.5 * travel));
    }
    if (s.blower !== p.blower || s.ac !== p.ac) blowerLevel(s.ac ? s.blower : 0);
  }, [s]);
}
